document.addEventListener("DOMContentLoaded", () => {
  const checkbox = document.getElementById("acceptance");
  const button = document.querySelector(".cart-recap button");
  const note = document.querySelector(".cart-footer-aggrements-note");

  if (!checkbox || !button || !note) return;

  const toggle = () => {
    const ok = checkbox.checked;

    button.classList.toggle("cart-recap-btn--disabled", !ok);
    button.toggleAttribute("disabled", !ok);
    note.hidden = ok;
    note.setAttribute("aria-hidden", String(ok));
  };

  toggle();
  checkbox.addEventListener("change", toggle);
  
});
